import React from 'react';
import styled from 'styled-components';

import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

import { formatTime } from 'ff/debrief/utils';
import OverallScoreBar from 'ff/debrief/components/segments/OverallScoreBar';
import RenderFetchingState from '../segments/FetchingState';

interface Props {
    origin?: string;
    dest?: string;
    start?: number;
    end?: number;
    score?: number;
    isError: boolean;
    isSuccess: boolean;
    isFetching: boolean;
    isLoading: boolean;
}

const TerminalDetailsWithScore: React.FC<Props> = props => {
    let content;

    switch (true) {
        case props.isLoading:
        case props.isError:
            content = <RenderFetchingState />;
            break;
        case props.isSuccess:
            content = <OverallScoreBar score={props.score} />;
            break;
        default:
            content = null;
    }

    return (
        <Container>
            <Stack direction="row" justifyContent="space-between">
                <Stack>
                    <AirportCode>{props.origin}</AirportCode>
                    <Date>{formatTime(props.start)}</Date>
                </Stack>
                <Stack>
                    <AirportCode textAlign="end">{props.dest}</AirportCode>
                    <Date textAlign="end">{formatTime(props.end)}</Date>
                </Stack>
            </Stack>
            {
                <Box bgcolor="#eeeeee" borderRadius="6px" pb={3} px={1} pt={1}>
                    {content}
                </Box>
            }
        </Container>
    );
};

const Container = styled(Stack)`
    align-items: stretch;
    justify-content: space-between;
    height: 100%;
    position: relative;
    &::after {
        content: '';
        border-right: 1px solid rgba(0, 0, 0, 0.05);
        display: flex;
        width: 1px;
        position: absolute;
        right: -12px;
        top: -12px;
        bottom: -12px;
    }
`;

const AirportCode = styled(Typography)`
    font-size: 16px;
    font-weight: 700;
`;

const Date = styled(Typography)`
    color: #424853;
`;

export default TerminalDetailsWithScore;
